module.exports = __webpack_public_path__ + "static/media/frozen-root-beer-mb-back-up-en.e502f841.jpg";